import styles from '../styles/Contact.module.css';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import contact from '../assets/contact.jpg'; // Or use "/logo.png" if placed in /public

const center = [46.563360, 13.959648];

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl:
        'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.3/images/marker-icon-2x.png',
    iconUrl:
        'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.3/images/marker-icon.png',
    shadowUrl:
        'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.3/images/marker-shadow.png',
});

const Contact = () => {
    return (
        <section className={styles.wrapper} id="contact">

            <div className={styles.container}>

                {/* LEFT SIDE */}
                <div className={styles.left}>
                    <h1>Kontakt</h1>
                    <div className={styles.imageBox}>
                        <img src={contact} alt="Dreamgarage Contact" className={styles.contactImage} />
                    </div>

                    <div className={styles.contactBox}>
                        <h2>Kontakt</h2>

                        <p>
                            <span className="material-icons">location_on</span>
                            Zur Weide 14, 9581 Ledenitzen
                        </p>
                        <p>
                            <span className="material-icons">email</span>
                            <a href="mailto:office@dreamgarage.at">office@dreamgarage.at</a>
                        </p> 
                        <p>
                            <span className="material-icons">call</span>
                            <a href="tel:+436701909413"> +43 670 1909413</a>
                        </p>
                    </div>

                </div>

                {/* RIGHT SIDE */}
                <div className={styles.mapBox}>
                    <h1>Anfahrt</h1>
                    <MapContainer center={center} zoom={15} className={styles.map} >
                    <section id="anfahrt">
                        <TileLayer
                            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        />
                        <Marker position={center}>
                            <Popup>Zur Weide 14, 9581</Popup>
                        </Marker>
                    </section>
                    </MapContainer>
                </div>

            </div>

        </section>
    );
};

export default Contact;